import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

type AdminPortalIntent = "sso" | "dsync";

interface GenerateLinkParams {
  intent: AdminPortalIntent;
  return_url?: string;
}

interface GenerateLinkResponse {
  link: string;
}

/**
 * Generate a short-lived WorkOS Admin Portal URL for SSO or
 * Directory Sync configuration.
 */
export const useGenerateAdminPortalLink = (organizationId: number) => {
  const userToken = useAuth()?.userToken;
  return useMutation({
    mutationFn: async (params: GenerateLinkParams): Promise<GenerateLinkResponse> =>
      fetch(ENDPOINTS.identity.admin_portal_link(organizationId), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken ?? ""}`,
        },
        body: JSON.stringify({
          intent: params.intent,
          return_url: params.return_url ?? window.location.href,
        }),
      }).then(handleResponse),
  });
};
